<template>
	<div id="app">
		<a-layout id="components-layout-demo-custom-trigger" v-if="!login">
			<a-layout-sider :trigger="null" collapsible v-model="collapsed" style="box-shadow:  5px 2px 10px 0px #dfdfdf;min-height: 100vh;z-index: 101"
			 theme="dark" width="250">
				<div class="logo">
					<span slot="title">
						<span v-if="!collapsed">
							<a-avatar shape="square" :src="info.weblogo" size="large" /> {{info.webname}}</span>
						<span v-if="collapsed">
							<a-avatar shape="square" :src="info.weblogo" size="large" /></span>
					</span>
				</div>
				<sider-nav></sider-nav>
			</a-layout-sider>
			<a-layout>
				<a-layout-header style="background: #fff;padding:0;box-shadow:  0px 2px 7px 0px #dfdfdf;z-index: 100;">
					<a-row type="flex" justify="space-between">
						<a-col>
							<a-icon class="trigger" :type="collapsed ? 'menu-unfold' : 'menu-fold'" @click="()=> collapsed = !collapsed" />
						</a-col>
						<a-col>
							<a-dropdown style="padding-right: 1rem;padding-left: 3rem;">
								<a class="ant-dropdown-link" href="#">
									欢迎！ {{adminName}}
									<a-icon type="down" />
								</a>
								<a-menu slot="overlay">
									<a-menu-item key="3" @click="out">退出登录</a-menu-item>
								</a-menu>
							</a-dropdown>
						</a-col>
					</a-row>
				</a-layout-header>
				<a-layout-content>
					<router-view />
				</a-layout-content>
				<a-layout-footer style="textAlign: center">
					技术支持 聚合大鱼科技
				</a-layout-footer>
			</a-layout>
		</a-layout>
		<div v-if="login">
			<router-view />
		</div>


	</div>
</template>

<script>
	import siderNav from '@/components/siderNav.vue'
	var storage = window.localStorage
  var timer = ''
	export default {
		name: 'app',
		components: {
			siderNav
		},
		data() {
			return {
				collapsed: false,
				defaultSelect: '1',
				breadcrumbArr: [{
					title: '首页',
					url: '/home'
				}],
				login: true,
				orderNum: '',
				info: {
          weblogo: require('@/assets/fav.png'),
          webname: '车间日报管理系统',
        },
				adminName: '',
				mySf: '',
				myId: '',
			}
		},
		mounted() {
			if (storage.breadcrumbArr) {
				this.breadcrumbArr = JSON.parse(storage.breadcrumbArr)
				this.defaultSelect = storage.defaultSelect
			}
			if (storage.loginStatus == 1) {
				this.login = false
			} else {
				this.login = true
				this.$router.push('/login')
			}
			this.mySf = storage.sf;
			this.myId = storage.adminId;
			this.adminName = storage.account;
		},
		watch: {
			$route(to, from) {
				if (storage.loginStatus == 1) {
					this.login = false
				} else {
					this.login = true
					this.$router.push('/login')
				}
				this.mySf = storage.sf;
				this.myId = storage.adminId;
				this.adminName = storage.account;
			}

		},
		methods: {
			out() {
				storage.clear()
				this.$router.push('/login')
			},
			toPage(e) {
				if (e != '') {
					this.$router.push(e)
				}
			},
			selectMenu(e) {
				storage.defaultSelect = e.key
				this.defaultSelect = e.key
				var bcArr = []
				for (var i = e.keyPath.length - 1; i >= 0; i--) {
					var obj = {
						title: e.keyPath[i].split('#')[1],
						url: e.keyPath[i].split('#')[2]
					}
					bcArr.push(obj)
				}
				this.breadcrumbArr = bcArr
				storage.breadcrumbArr = JSON.stringify(bcArr)
			},
		}
	}
</script>

<style lang="less">
	#components-layout-demo-custom-trigger .trigger {
		font-size: 18px;
		line-height: 64px;
		padding: 0 24px;
		cursor: pointer;
		transition: color .3s;
	}

	#components-layout-demo-custom-trigger .trigger:hover {
		color: #1890ff;
	}

	#components-layout-demo-custom-trigger .logo {
		height: 64px;
		line-height: 64px;
		text-align: center;
		color: #fff;
		font-weight: 500;
		font-size: 1rem;
	}

	.breadcrumbClass:hover {
		cursor: pointer;
	}

	.font-danger {
		color: #f5222d
	}

	.font-warning {
		color: #FFCC33;
	}

	.font-success {
		color: #66CC00;
	}

	.mainBox {
		padding: 20px;
	}

	.searchBox {
		background: #fff;
		padding: 20px;
		margin-bottom: 20px;
	}

	.contentBox {
		background: #fff;
		padding: 20px;
	}
		
	.text-gray{
		color:#bfbfbf
	}
  
  .pointer:hover {
    cursor: pointer;
  }
  
  .searchBox {
      padding: 20px;
      background: #fff;
      display: flex;
      -webkit-box-pack: justify;
      justify-content: space-between;
      -webkit-box-align: center;
      align-items: center;
  }
  
  .mainBox {
      margin: 20px;
      background: #fff;
  }
</style>
